import { ACCESS_KEY, urlAPI } from '../../../urls'
import { dataFetchingFinish, dataFetchingStart, setWhereAfterToGo } from '../../slices/modalSlice'
import { type AppDispatch, type RootState } from '../../store'
import { getErrorss } from '../../../functions/errors/GetErrors'
import _ from 'lodash'
import { type IFile } from '../../../types'
import { uploadStrapiFile } from '../fileActions'
import { nanoid } from 'nanoid'

import { getQueryUnits } from '../../../functions/shared/api/queries/getQueryUnits'
import {   setUnitsState, type Unit } from '../../slices/unitsSlice'
import { sendUnitNotification } from '../unitsActions'

export const createMarketingForUnit = (data: any) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {

    try {
        dispatch(dataFetchingStart())
        const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''

        const images: Array<IFile | null> = getState().modal.images
        const storedImages = _.filter(images, (image) => !_.includes(image?.data, 'data:'))
        const notUploadedImages = _.filter(images, (image) => _.includes(image?.data, 'data:'))

        const uploadedImages = await Promise.all(_.map(notUploadedImages, async (image) => {
            const res: Response = await fetch(image?.data ?? '')
            const blob: Blob = await res.blob()
            const file = new File([blob], `unit-image-${nanoid()}`, { type: blob.type })
            return await uploadStrapiFile(file, 'properties', null, `unit-image-${nanoid()}`)
        }))
        const unitBody: any = {
            Marketing: {},
            Statuses : ['Door close']
        }

        if (storedImages.includes(images[0])) {
            unitBody.Images = _.map([...storedImages, ...uploadedImages], (image) => image?.data)
        } else {
            unitBody.Images = _.map([...uploadedImages, ...storedImages], (image) => image?.data)
        }

  
        if (data.StatusesMortgage && !unitBody.Statuses.includes('Mortgage')) {
            unitBody.Statuses.push('Mortgage')
        }
    

      

        unitBody.Marketing.Headline = data?.Marketing?.Headline
        unitBody.Marketing.Description = data?.Marketing?.Description
        unitBody.Marketing.Price = data?.Marketing?.Price
        unitBody.Marketing.Use = data?.Marketing?.Payments ? 'For rent' : 'For sale'
        unitBody.Marketing.Checks = data?.Marketing?.Payments
        unitBody.ManagedBy = 'Agent'
     
        const bodyObject = {
            method: 'PUT',
            collection: 'units',
            id: Number(data.unitID),
            body: unitBody,
            query: getQueryUnits()
        }

        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(bodyObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })

        const responseJSON = await response?.json() as unknown as any
        if (responseJSON.success) {
            if (responseJSON.response.error != null) {
                dispatch(dataFetchingFinish())
                return { ...responseJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(responseJSON) }
            } else {
                void sendUnitNotification(responseJSON.response.data as Unit, 'user-unit-new')
                dispatch(setUnitsState(responseJSON.response.data))
                dispatch(dataFetchingFinish())
                dispatch(setWhereAfterToGo('/agent/my_units'))
                return {
                    textNavigate: `/agent/modalView/unit_modal/${data?.unitID}/not/agent_s_unit`,
                    isSuccessful: true,
                    textNotification: 'Unit is added successfully',
                    title: 'Success'
                }
            }
        } else {
            dispatch(dataFetchingFinish())
            return { textNavigate: '', isSuccessful: false, textNotification: '' }
        }
    } catch (error) {
        dispatch(dataFetchingFinish())
        console.log(error)
        return {
            isSuccessful: false
        }
    }
}

